import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "@constructionautomation/backend";
import { orgRoleHasCapability } from "@constructionautomation/backend/convex/lib/orgRoles";

const MAX_CONTACTS = 3;

/** The first few company admins, who can grant project and edit access. */
export function useAccessManagers({ enabled = true }: { enabled?: boolean } = {}) {
  const { data: members } = useQuery(
    convexQuery(api.auth.listOrganizationMembersMinimal, enabled ? {} : "skip")
  );
  return (members ?? [])
    .filter((member) => orgRoleHasCapability(member.orgRole, "manage_members"))
    .slice(0, MAX_CONTACTS);
}

export function requestAccessHref(email: string, subject: string, body: string) {
  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}
